import { CongratulationsModule } from 'modules';

export const CongratulationScreen = () => {
  return <CongratulationsModule />;
};
